var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-masker-box"},[_vm._t("default"),_c('div',{staticClass:"vux-masker",class:{'vux-masker-fullscreen': _vm.fullscreen},style:(_vm.style)},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }